import { OrderFormat } from '@ancon/wildcat-types'

export default function isSystemProductOrder(orderFormat?: OrderFormat) {
  return orderFormat === OrderFormat.System
}
